export function matchMimeType(allowedType: string, testType: string) {
    const regexp = new RegExp(`^${allowedType.replace('*', '.+')}$`);
    return regexp.test(testType);
}
